import type { FC } from 'react';
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { GetColor } from 'venn-ui-kit';
import Bar from '../../../bar/Bar';
import { formatValue } from '../utils';
import type { DataType } from './Chart';
import { OptionIcon } from '../../../common/OptionIcon';

const StyledRow = styled.tr`
  font-size: 10px;
  line-height: 1.6;
  text-align: right;
`;

const FirstCell = styled.td`
  text-align: left;
  width: 138px;
  font-weight: 700;
`;

const ContributionCell = styled.td`
  color: ${GetColor.DataLineColor.Gold};
  width: 60px;
`;

const RiskCell = styled.td`
  width: 60px;
`;

const BarCell = styled.td`
  width: 80px;
`;

export const StyledBar = styled(Bar)`
  border: 1px solid ${GetColor.GreyScale.Grey40};
`;

const FirstCellContent = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

interface Props {
  row: DataType;
  max: number;
  usePercentages: boolean;
}

const Row: FC<React.PropsWithChildren<Props>> = ({ row, max, usePercentages }) => {
  const { Colors } = useContext(ThemeContext);
  return (
    <StyledRow>
      <FirstCell>
        <div className="flex flex-row w-[133px] items-center">
          <FirstCellContent>{row.name}</FirstCellContent>
          {row.optionData && <OptionIcon optionType={row.optionData.optionType} />}
        </div>
      </FirstCell>
      <BarCell>
        <StyledBar
          barColor={Colors.DataBarColor.LightGold}
          value={(row.contribution * 100) / max}
          barHeight={10}
          barWidth={80}
        />
      </BarCell>
      <ContributionCell>{formatValue(row.contribution, true)}</ContributionCell>
      <RiskCell>{formatValue(row.unweightedExposure, usePercentages)}</RiskCell>
    </StyledRow>
  );
};

export default Row;
